var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgDaycareCenter = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 32,
  height: 29,
  fill: "#05B86C",
  "aria-hidden": "true",
  viewBox: "0 0 32 29"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M18 18a2 2 0 0 0-2 2v4a2 2 0 0 0 2 2h7a2 2 0 0 0 2-2v-4a2 2 0 0 0-2-2zm7 2h-7v4h7z",
  clipRule: "evenodd"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M30.279 1.671A2 2 0 0 0 28.306 0H3.694a2 2 0 0 0-1.973 1.671L0 12c0 1.45.836 2.618 2 3.246V29h28V15.246c1.164-.628 2-1.795 2-3.246zM8 2H3.694l-1.333 8H7zm2 0-1 8h6V2zm13 8h-6V2h5zm2 0h4.64l-1.334-8H24zM4 13.875c-1.36 0-2.222-.97-2.222-1.875h4.444c0 .905-.861 1.875-2.222 1.875m0 1.875c2.076 0 4-1.549 4-3.75 0 2.201 1.924 3.75 4 3.75s4-1.549 4-3.75c0 2.201 1.924 3.75 4 3.75s4-1.549 4-3.75c0 2.201 1.924 3.75 4 3.75V27H14v-7a1 1 0 1 0 0-2H6a1 1 0 1 0 0 2v7H4zm8-1.875c-1.36 0-2.222-.97-2.222-1.875h4.444c0 .905-.861 1.875-2.222 1.875m8 0c-1.36 0-2.222-.97-2.222-1.875h4.444c0 .905-.861 1.875-2.222 1.875m8 0c-1.36 0-2.222-.97-2.222-1.875h4.444c0 .905-.861 1.875-2.222 1.875M8 20v7h4v-7z",
  clipRule: "evenodd"
})));
export default SvgDaycareCenter;